import { useTranslation } from 'react-i18next'

interface Props {
  onClick: () => void
  disabled?: boolean
  testId?: string
}

export function AnswerEditButton({ onClick, disabled = false, testId = 'edit-answer-btn' }: Props) {
  const { t } = useTranslation('coaching')

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className="rounded-md border border-gray-300 px-3 py-1 text-xs font-semibold text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {t('override.editAnswer')}
    </button>
  )
}

export function AnswerEditCancelButton({
  onClick,
  disabled = false,
  testId = 'cancel-answer-edit-btn',
}: Props) {
  const { t } = useTranslation('coaching')

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className="rounded-md border border-gray-300 bg-white px-3 py-1 text-xs font-semibold text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {t('override.cancelEdit')}
    </button>
  )
}
